export default __webpack_public_path__ + "static/media/yoga.0c968e4a.png";